import { io } from "socket.io-client";

// "undefined" means the URL will be computed from the `window.location` object
const URL = import.meta.env.MODE === "production" ? undefined : import.meta.env.MODE === "staging" ? "https://preweb.lynkid.io" : "https://web.lynkid.io";
// const URL = "http://localhost:8983";
export const socket = io(URL, { transports: ["websocket"] });
